module.exports = __webpack_public_path__ + "static/media/bg_ticked_zone.44a9260a.png";